export default "__VITE_ASSET__a18cf80f__"